module.exports = __webpack_public_path__ + "static/media/1350_ItemSelection_Medical_step3.4b0119f9.png";